export const topbarCopy = {
  standardKicker: "AS/NZS 3000 clause search workspace",
  compactKicker: "Australian Standards",
  subtitle: "Clause lookup workspace"
} as const;

export const loadingCopy = {
  checkingWorkspace: "Checking your workspace",
  loadingUsers: "Loading users"
} as const;

